import { render } from "./Scenes.vue?vue&type=template&id=5d5d95bd&scoped=true"
import script from "./Scenes.vue?vue&type=script&lang=js"
export * from "./Scenes.vue?vue&type=script&lang=js"

import "./Scenes.vue?vue&type=style&index=0&id=5d5d95bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5d95bd"]])

export default __exports__